export default __webpack_public_path__ + "c04865c3360891aa83a6dca567b90643.svg";